import { Table } from 'antd'
import Title from 'antd/es/typography/Title'
import { FC } from 'react'
import TableWrapper from '../../../../components/table-wrapper/table-wrapper'
import { columns } from './columns'
import { useGetPrintQueueEntriesQuery } from '../../../../store/api/print-queue-entries-api'
import useTablePagination from '../../../../hooks/table-pages/use-table-pagination'
import useEndpointQueryParams, {
    DeserializeFilters,
} from '../../../../hooks/table-pages/use-endpoint-query-parameters'

const PrintPreparationTable: FC = () => {
    const deserializeFilters: DeserializeFilters = filtersString => {
        return {}
    }
    const params = useEndpointQueryParams({ deserializeFilters })

    const { data, isLoading } = useGetPrintQueueEntriesQuery(
        {
            sort: ['sort:asc', 'id:asc'],
            pagination: params.pagination,
            populate: {
                print_job: {
                    populate: {
                        shipment: {
                            populate: {
                                client: true,
                                shipment_positions: true,
                                stamp: { populate: { tube: true } },
                                blankPreviewFiles: true,
                            },
                        },
                    },
                },
                machine: true,
            },
        },
        { pollingInterval: 120000 }
    )

    const pagination = useTablePagination(params, data)

    return (
        <TableWrapper style={{ flex: 'auto' }} tableHasNotPagination>
            <Table
                loading={isLoading}
                title={() => (
                    <Title style={{ marginTop: 0 }} level={4}>
                        Очередь
                    </Title>
                )}
                dataSource={data?.data}
                columns={columns}
                pagination={pagination}
                rowKey='documentId'
                size='small'
            />
        </TableWrapper>
    )
}

export default PrintPreparationTable
